import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { api } from '../services/api.js'
import { useAuth } from '../services/auth.jsx'

export default function FazendasPage() {
  const { setCurrentFazenda } = useAuth()
  const navigate = useNavigate()
  const [fazendas, setFazendas] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [showForm, setShowForm] = useState(false)
  const [editingFazenda, setEditingFazenda] = useState(null)

  async function fetchFazendas() {
    try {
      const data = await api.getFazendas()
      setFazendas(data)
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { fetchFazendas() }, [])

  async function handleToggleActive(fazenda) {
    try {
      await api.updateFazenda(fazenda.id, { active: !fazenda.active })
      await fetchFazendas()
    } catch (e) {
      setError(e.message)
    }
  }

  async function handleDelete(fazenda) {
    if (!window.confirm(`Excluir fazenda "${fazenda.name}"? Esta ação só é possível se não houver áreas ou usuários vinculados.`)) return
    try {
      await api.deleteFazenda(fazenda.id)
      await fetchFazendas()
    } catch (e) {
      setError(e.message)
    }
  }

  function handleSelect(fazenda) {
    setCurrentFazenda({ id: fazenda.id, name: fazenda.name })
    navigate('/')
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f0fdf4' }}>
      {/* Header */}
      <div style={{ background: '#14532d', padding: '0 24px', height: 60, display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/" style={{ color: '#86efac', textDecoration: 'none', fontSize: 13, fontWeight: 600 }}>← Dashboard</Link>
        <span style={{ color: 'rgba(255,255,255,0.3)' }}>|</span>
        <span style={{ fontSize: 26 }}>🌾</span>
        <div style={{ fontSize: 16, fontWeight: 800, color: '#fff' }}>Gerenciar Fazendas</div>
        <button
          onClick={() => { setEditingFazenda(null); setShowForm(true) }}
          style={{ marginLeft: 'auto', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 10, padding: '8px 16px', cursor: 'pointer', fontWeight: 700, fontSize: 13 }}
        >
          ➕ Nova Fazenda
        </button>
      </div>

      <div style={{ maxWidth: 640, margin: '32px auto', padding: '0 16px' }}>
        {error && (
          <div style={{ background: '#fee2e2', color: '#7f1d1d', padding: '12px 16px', borderRadius: 10, fontWeight: 600, fontSize: 13, marginBottom: 16 }}>
            Erro: {error}
            <button onClick={() => setError('')} style={{ marginLeft: 12, background: 'none', border: 'none', cursor: 'pointer', color: '#7f1d1d', fontWeight: 800 }}>×</button>
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', color: '#64748b', padding: 40 }}>Carregando...</div>
        ) : (
          <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
            {fazendas.length === 0 && (
              <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>Nenhuma fazenda cadastrada.</div>
            )}
            {fazendas.map((fazenda, idx) => (
              <div key={fazenda.id} style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '14px 20px',
                borderBottom: idx < fazendas.length - 1 ? '1px solid #e7f3ea' : 'none',
                background: fazenda.active ? '#fff' : '#f8fafc',
              }}>
                {/* Icon */}
                <div style={{ width: 38, height: 38, borderRadius: 999, flexShrink: 0, background: '#052e16', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                  🏡
                </div>

                {/* Info — clicável para selecionar */}
                <div
                  style={{ flex: 1, minWidth: 0, cursor: fazenda.active ? 'pointer' : 'default' }}
                  onClick={() => fazenda.active && handleSelect(fazenda)}
                  title={fazenda.active ? 'Clique para abrir no dashboard' : undefined}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontWeight: 700, color: fazenda.active ? '#0f172a' : '#94a3b8', fontSize: 14 }}>{fazenda.name}</span>
                    {!fazenda.active && (
                      <span style={{ fontSize: 10, background: '#f1f5f9', color: '#94a3b8', borderRadius: 999, padding: '1px 7px', fontWeight: 700 }}>inativa</span>
                    )}
                    {fazenda.active && (
                      <span style={{ fontSize: 10, color: '#16a34a', fontWeight: 600 }}>→ abrir</span>
                    )}
                  </div>
                </div>

                {/* Actions */}
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button
                    onClick={() => { setEditingFazenda(fazenda); setShowForm(true) }}
                    style={actionBtn('#f1f5f9', '#475569')}
                    title="Editar nome"
                  >✏️</button>
                  <button
                    onClick={() => handleToggleActive(fazenda)}
                    style={actionBtn(fazenda.active ? '#fef9c3' : '#dcfce7', fazenda.active ? '#713f12' : '#15803d')}
                    title={fazenda.active ? 'Desativar' : 'Ativar'}
                  >
                    {fazenda.active ? '⏸' : '▶'}
                  </button>
                  <button
                    onClick={() => handleDelete(fazenda)}
                    style={actionBtn('#fee2e2', '#b91c1c')}
                    title="Excluir"
                  >🗑</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showForm && (
        <FazendaFormModal
          fazenda={editingFazenda}
          onSave={async (data) => {
            if (editingFazenda) {
              await api.updateFazenda(editingFazenda.id, data)
            } else {
              await api.createFazenda(data)
            }
            await fetchFazendas()
            setShowForm(false)
          }}
          onClose={() => setShowForm(false)}
        />
      )}
    </div>
  )
}

function FazendaFormModal({ fazenda, onSave, onClose }) {
  const [name, setName] = useState(fazenda?.name ?? '')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function handleSave() {
    if (!name.trim()) return setError('Nome é obrigatório')
    setSaving(true)
    setError('')
    try {
      await onSave({ name: name.trim() })
    } catch (e) {
      setError(e.message)
      setSaving(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
      <div style={{ background: '#14532d', borderRadius: 16, padding: '28px 32px', maxWidth: 380, width: '100%', boxShadow: '0 8px 40px rgba(0,0,0,0.4)' }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 11, color: '#86efac', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 4 }}>
          {fazenda ? 'Editar Fazenda' : 'Nova Fazenda'}
        </div>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 20 }}>
          {fazenda ? '✏️ Editar dados' : '➕ Adicionar fazenda'}
        </div>

        <label style={lbl}>Nome da fazenda *</label>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleSave() }}
          style={inp}
          placeholder="Ex: Faz. Boa Esperança"
          autoFocus
        />

        {error && <div style={{ background: '#fee2e2', color: '#7f1d1d', padding: '8px 12px', borderRadius: 8, fontSize: 13, marginTop: 12 }}>{error}</div>}

        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button onClick={onClose} disabled={saving} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1.5px solid rgba(255,255,255,0.2)', background: 'transparent', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>Cancelar</button>
          <button onClick={handleSave} disabled={saving} style={{ flex: 2, padding: '10px 0', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
            {saving ? 'Salvando...' : fazenda ? 'Salvar' : 'Criar fazenda'}
          </button>
        </div>
      </div>
    </div>
  )
}

const lbl = { display: 'block', fontSize: 10, fontWeight: 700, color: '#86efac', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 4 }
const inp = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #16a34a', background: '#052e16', color: '#fff', fontSize: 14, boxSizing: 'border-box', outline: 'none' }

function actionBtn(bg, color) {
  return { background: bg, border: 'none', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 15, color, lineHeight: 1 }
}
